/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    BulkArchiveTestingActivitiesData,
    ControlActivityOverviewListDto,
    TActTableRowListDto,
    TestingActivityDto,
    TestingActivityId,
    TestingActivityReassignment,
    TestingActivitySubmissionKind,
    TestingProgramId,
    UpdatableTestingActivity,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getTestingActivitiesTestingActivityId = (
    testingActivityId: TestingActivityId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingActivityDto>> => {
    return axios.get(`/api/testing-activities/${testingActivityId}`, options);
};

export const getGetTestingActivitiesTestingActivityIdQueryKey = (
    testingActivityId: TestingActivityId
) => {
    return [`/api/testing-activities/${testingActivityId}`] as const;
};

export const getGetTestingActivitiesTestingActivityIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingActivitiesTestingActivityIdQueryKey(testingActivityId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>
    > = ({ signal }) =>
        getTestingActivitiesTestingActivityId(testingActivityId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: testingActivityId !== null && testingActivityId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingActivitiesTestingActivityIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>
>;
export type GetTestingActivitiesTestingActivityIdQueryError = AxiosError<null>;

export function useGetTestingActivitiesTestingActivityId<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingActivitiesTestingActivityId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingActivitiesTestingActivityId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityId<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingActivitiesTestingActivityId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingActivitiesTestingActivityId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityId<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesTestingActivityId<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTestingActivitiesTestingActivityIdQueryOptions(
        testingActivityId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingActivitiesTestingActivityIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingActivitiesTestingActivityIdQueryKey(testingActivityId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>
    > = ({ signal }) =>
        getTestingActivitiesTestingActivityId(testingActivityId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingActivitiesTestingActivityIdSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>
    >;
export type GetTestingActivitiesTestingActivityIdSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingActivitiesTestingActivityIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesTestingActivityIdSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesTestingActivityId>>,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesTestingActivityId>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingActivitiesTestingActivityIdSuspenseQueryOptions(
            testingActivityId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postTestingActivitiesTestingActivityId = (
    testingActivityId: TestingActivityId,
    testingActivitySubmissionKind: TestingActivitySubmissionKind,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/testing-activities/${testingActivityId}`,
        testingActivitySubmissionKind,
        options
    );
};

export const getPostTestingActivitiesTestingActivityIdMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>,
        TError,
        {
            testingActivityId: TestingActivityId;
            data: TestingActivitySubmissionKind;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>,
    TError,
    {
        testingActivityId: TestingActivityId;
        data: TestingActivitySubmissionKind;
    },
    TContext
> => {
    const mutationKey = ["postTestingActivitiesTestingActivityId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>,
        {
            testingActivityId: TestingActivityId;
            data: TestingActivitySubmissionKind;
        }
    > = (props) => {
        const { testingActivityId, data } = props ?? {};

        return postTestingActivitiesTestingActivityId(
            testingActivityId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTestingActivitiesTestingActivityIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>
>;
export type PostTestingActivitiesTestingActivityIdMutationBody =
    TestingActivitySubmissionKind;
export type PostTestingActivitiesTestingActivityIdMutationError =
    AxiosError<null>;

export const usePostTestingActivitiesTestingActivityId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>,
            TError,
            {
                testingActivityId: TestingActivityId;
                data: TestingActivitySubmissionKind;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTestingActivitiesTestingActivityId>>,
    TError,
    {
        testingActivityId: TestingActivityId;
        data: TestingActivitySubmissionKind;
    },
    TContext
> => {
    return useMutation(
        getPostTestingActivitiesTestingActivityIdMutationOptions(options),
        queryClient
    );
};
export const patchTestingActivitiesTestingActivityId = (
    testingActivityId: TestingActivityId,
    updatableTestingActivity: UpdatableTestingActivity,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/testing-activities/${testingActivityId}`,
        updatableTestingActivity,
        options
    );
};

export const getPatchTestingActivitiesTestingActivityIdMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>,
        TError,
        {
            testingActivityId: TestingActivityId;
            data: UpdatableTestingActivity;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>,
    TError,
    { testingActivityId: TestingActivityId; data: UpdatableTestingActivity },
    TContext
> => {
    const mutationKey = ["patchTestingActivitiesTestingActivityId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>,
        { testingActivityId: TestingActivityId; data: UpdatableTestingActivity }
    > = (props) => {
        const { testingActivityId, data } = props ?? {};

        return patchTestingActivitiesTestingActivityId(
            testingActivityId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchTestingActivitiesTestingActivityIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>
>;
export type PatchTestingActivitiesTestingActivityIdMutationBody =
    UpdatableTestingActivity;
export type PatchTestingActivitiesTestingActivityIdMutationError =
    AxiosError<null>;

export const usePatchTestingActivitiesTestingActivityId = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>,
            TError,
            {
                testingActivityId: TestingActivityId;
                data: UpdatableTestingActivity;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchTestingActivitiesTestingActivityId>>,
    TError,
    { testingActivityId: TestingActivityId; data: UpdatableTestingActivity },
    TContext
> => {
    return useMutation(
        getPatchTestingActivitiesTestingActivityIdMutationOptions(options),
        queryClient
    );
};
export const getTestingActivitiesTestingActivityIdControlActivitiesSamples = (
    testingActivityId: TestingActivityId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlActivityOverviewListDto>> => {
    return axios.get(
        `/api/testing-activities/${testingActivityId}/control-activities-samples`,
        options
    );
};

export const getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryKey =
    (testingActivityId: TestingActivityId) => {
        return [
            `/api/testing-activities/${testingActivityId}/control-activities-samples`,
        ] as const;
    };

export const getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
            >
        >,
        TError = AxiosError<null>,
    >(
        testingActivityId: TestingActivityId,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryKey(
                testingActivityId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                >
            >
        > = ({ signal }) =>
            getTestingActivitiesTestingActivityIdControlActivitiesSamples(
                testingActivityId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            enabled:
                testingActivityId !== null && testingActivityId !== undefined,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
            >
        >
    >;
export type GetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryError =
    AxiosError<null>;

export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamples<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamples<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamples<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamples<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryOptions(
            testingActivityId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
            >
        >,
        TError = AxiosError<null>,
    >(
        testingActivityId: TestingActivityId,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesQueryKey(
                testingActivityId
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                >
            >
        > = ({ signal }) =>
            getTestingActivitiesTestingActivityIdControlActivitiesSamples(
                testingActivityId,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
            >
        >
    >;
export type GetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense<
    TData = Awaited<
        ReturnType<
            typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
        >
    >,
    TError = AxiosError<null>,
>(
    testingActivityId: TestingActivityId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getTestingActivitiesTestingActivityIdControlActivitiesSamples
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspenseQueryOptions(
            testingActivityId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getTestingActivitiesPendingActivities = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TActTableRowListDto>> => {
    return axios.get(`/api/testing-activities/pending-activities`, options);
};

export const getGetTestingActivitiesPendingActivitiesQueryKey = () => {
    return [`/api/testing-activities/pending-activities`] as const;
};

export const getGetTestingActivitiesPendingActivitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingActivitiesPendingActivitiesQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>
    > = ({ signal }) =>
        getTestingActivitiesPendingActivities({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingActivitiesPendingActivitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>
>;
export type GetTestingActivitiesPendingActivitiesQueryError = AxiosError<null>;

export function useGetTestingActivitiesPendingActivities<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingActivitiesPendingActivities>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingActivitiesPendingActivities>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesPendingActivities<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getTestingActivitiesPendingActivities>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getTestingActivitiesPendingActivities>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesPendingActivities<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesPendingActivities<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingActivitiesPendingActivitiesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTestingActivitiesPendingActivitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetTestingActivitiesPendingActivitiesQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>
    > = ({ signal }) =>
        getTestingActivitiesPendingActivities({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTestingActivitiesPendingActivitiesSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>
    >;
export type GetTestingActivitiesPendingActivitiesSuspenseQueryError =
    AxiosError<null>;

export function useGetTestingActivitiesPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTestingActivitiesPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTestingActivitiesPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getTestingActivitiesPendingActivities>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getTestingActivitiesPendingActivities>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetTestingActivitiesPendingActivitiesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchTestingActivitiesReassign = (
    testingActivityReassignment: TestingActivityReassignment[],
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingProgramId[]>> => {
    return axios.patch(
        `/api/testing-activities/reassign`,
        testingActivityReassignment,
        options
    );
};

export const getPatchTestingActivitiesReassignMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchTestingActivitiesReassign>>,
        TError,
        { data: TestingActivityReassignment[] },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchTestingActivitiesReassign>>,
    TError,
    { data: TestingActivityReassignment[] },
    TContext
> => {
    const mutationKey = ["patchTestingActivitiesReassign"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchTestingActivitiesReassign>>,
        { data: TestingActivityReassignment[] }
    > = (props) => {
        const { data } = props ?? {};

        return patchTestingActivitiesReassign(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchTestingActivitiesReassignMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchTestingActivitiesReassign>>
>;
export type PatchTestingActivitiesReassignMutationBody =
    TestingActivityReassignment[];
export type PatchTestingActivitiesReassignMutationError = AxiosError<null>;

export const usePatchTestingActivitiesReassign = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchTestingActivitiesReassign>>,
            TError,
            { data: TestingActivityReassignment[] },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchTestingActivitiesReassign>>,
    TError,
    { data: TestingActivityReassignment[] },
    TContext
> => {
    return useMutation(
        getPatchTestingActivitiesReassignMutationOptions(options),
        queryClient
    );
};
export const postTestingActivitiesArchive = (
    bulkArchiveTestingActivitiesData: BulkArchiveTestingActivitiesData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/api/testing-activities/archive`,
        bulkArchiveTestingActivitiesData,
        options
    );
};

export const getPostTestingActivitiesArchiveMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTestingActivitiesArchive>>,
        TError,
        { data: BulkArchiveTestingActivitiesData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTestingActivitiesArchive>>,
    TError,
    { data: BulkArchiveTestingActivitiesData },
    TContext
> => {
    const mutationKey = ["postTestingActivitiesArchive"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTestingActivitiesArchive>>,
        { data: BulkArchiveTestingActivitiesData }
    > = (props) => {
        const { data } = props ?? {};

        return postTestingActivitiesArchive(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTestingActivitiesArchiveMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTestingActivitiesArchive>>
>;
export type PostTestingActivitiesArchiveMutationBody =
    BulkArchiveTestingActivitiesData;
export type PostTestingActivitiesArchiveMutationError = AxiosError<null>;

export const usePostTestingActivitiesArchive = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTestingActivitiesArchive>>,
            TError,
            { data: BulkArchiveTestingActivitiesData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTestingActivitiesArchive>>,
    TError,
    { data: BulkArchiveTestingActivitiesData },
    TContext
> => {
    return useMutation(
        getPostTestingActivitiesArchiveMutationOptions(options),
        queryClient
    );
};
